import {
  Button,
  Checkbox,
  InfiniteScroll,
  List,
  Popup,
  Radio,
  SearchBar,
  Toast
} from "antd-mobile";
import { debounce } from "lodash";
import React, { useCallback, useEffect, useRef, useState } from "react";

import { connect, mapProps, mapReadPretty, useField } from "@formily/react";
import "./index.less";
import { getAdminstrative, getUserList } from "../../services/common";
import { isValid } from "@formily/shared";

type PublicComponentType = "personnel" | "department";

interface Item {
  id: string;
  name: string;
}
interface ListItemCheckboxProps {
  item: Item;
  onClick: (item: Item) => void;
}

interface IProps {
  value?: string[] | string;
  type?: PublicComponentType;
  model?: "single" | "multiple";
  max?: number;
  onChange?: (items: string[] | string) => void;
  placeholder?: string;
}

const SearchSelectorModel = (props: IProps) => {
  const {
    model,
    value: checkedItems = model === "single" ? "" : [],
    placeholder = "请选择",
    max = 20,
    type,
    onChange = () => {},
  } = props;
  const pageSize = 10;
  const [selected, setSelected] = useState<Item[]>([]);
  const [allItems, setAllItems] = useState<Item[]>([]); // 弹窗中展示的列表，直接展示后端返回的数据，前端不做处理
  const [searchText, setSearchText] = useState<string>("");
  const [open, setOpen] = useState(false);
  const modalConatinerRef = useRef(null);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
  const [, setRefresh] = useState({}); // 强制重新渲染本组件，目的是解决antd-mobile的List组件a标签样式bug

  useEffect(() => {
    if (!open) {
      setSearchText("");
    }
  }, [open]);

  const getAllItems = async (
    params: {
      searchTxt?: string;
      value?: string;
      pageNo?: number;
      pageSize?: number;
    },
    apiType: PublicComponentType,
    isReset?: boolean
  ) => {
    let res;
    const pageParam: any = {
      pageNo: params.value || isReset ? 1 : page,
      pageSize:
        params.value && model === 'multiple' ? checkedItems?.length : pageSize,
    };
    try {
      switch (apiType) {
        case "personnel":
          res = await getUserList({ ...params, ...pageParam });
          break;
        case "department":
          res = await getAdminstrative({ ...params, ...pageParam });
          break;
        default:
          break;
      }
      if (res && res?.data) {
        setPage(page + 1);
        if (res?.data?.length < pageSize) {
          setHasMore(false);
        } else {
          setHasMore(true);
        }
        const list: Item[] =
          res?.data?.map((item: any) => {
            return {
              id: item?.value,
              name: item?.label,
            };
          }) || [];
        if (isReset) {
          setAllItems(list);
        } else {
          setAllItems((val) => [...val, ...list]);
        }
        if (params?.value) {
          setSelected(list);
        }
      } else {
        setHasMore(false);
        setAllItems([]);
      }
    } catch (error) {
      console.log(error, "error");
    }
  };

  const debounceGetAllItems = useCallback(
    debounce(
      (
        params: { searchTxt?: string; value?: string },
        apiType: PublicComponentType
      ) => {
        getAllItems(params, apiType, true);
      },
      500
    ),
    []
  );

  // 防抖查询后端数据
  useEffect(() => {
    if (open) {
      debounceGetAllItems({ searchTxt: searchText }, type);
    }
  }, [searchText, open]);

  const ListItem: React.FC<ListItemCheckboxProps> = ({ item, onClick }) => {
    return (
      <List.Item
        key={item?.id}
        // arrowIcon={false}
        prefix={
          model === "multiple" ? (
            <Checkbox value={item?.id} />
          ) : (
            <Radio value={item?.id} />
          )
        }
        onClick={() => {
          onClick(item);
        }}
      >
        {item?.name}
      </List.Item>
    );
  };

  // 搜索处理函数
  const handleSearch = (value: string) => {
    setSearchText(value);
  };

  // 点击复选框的处理函数
  const handleCheckboxChange = (item: Item) => {
    // 如果点击的是已选中的复选框，则取消勾选
    if (
      Array.isArray(checkedItems) &&
      checkedItems?.find((i) => i === item?.id)
    ) {
      onChange(checkedItems?.filter((i) => i !== item?.id));
      setSelected(selected?.filter((i) => i?.id !== item?.id));
      return;
    }

    // 点击的是未选中的复选框，且已经激活的数量大于等于最大限制数量
    if (checkedItems?.length >= max) {
      Toast.show({
        icon: 'fail',
        content: `最多选择${max}条数据`,
        getContainer: modalConatinerRef?.current,
      });
      setRefresh({});
    } else {
      onChange([...checkedItems, item.id]);
      setSelected([...selected, item]);
    }
  };

  // 点击单选框的处理函数
  const handleRadioChange = (item: Item) => {
    onChange(item.id);
    setSelected([item]);
  };

  //点击确认，仅仅是关闭弹窗
  const handleConfirm = () => {
    if (model === "single") {
      onChange(
        Array.isArray(checkedItems) ? checkedItems?.[0] || '' : checkedItems,
      );
    }
    setOpen(false);
  };

  useEffect(() => {
    if (checkedItems?.length > 0 && !open) {
      if (model === "single") {
        getAllItems(
          {
            searchTxt: '',
            value: Array.isArray(checkedItems)
              ? checkedItems?.[0] || ''
              : checkedItems,
          },
          type,
          true
        );
      } else {
        getAllItems(
          {
            searchTxt: '',
            value: Array.isArray(checkedItems)
              ? checkedItems?.join(',')
              : checkedItems,
          },
          type,
          true
        );
      }
    }
  }, [checkedItems, type, model, open]);

  // useEffect(() => {
  //   if (checkedItems && allItems && allItems?.length > 0 && !open) {
  //     if (model === "single") {
  //       const checkedItem = allItems?.filter((i) => i.id === checkedItems?.[0]);
  //       setSelected(checkedItem);
  //     } else {
  //       const checkedItemsArr =
  //         typeof checkedItems === "string" ? [checkedItems] : checkedItems;
  //       const checkedItem = allItems?.filter((i) =>
  //         checkedItemsArr?.includes(i.id)
  //       );
  //       setSelected(checkedItem);
  //     }
  //   }
  // }, [checkedItems, allItems, model, open]);

  useEffect(() => {
    console.log(selected, "selected");
  }, [selected]);

  return (
    <div
      className={"searchSelector"}
      onClick={() => {
        setOpen(true);
      }}
    >
      {checkedItems?.length === 0 ? (
        <div className={"searchSelectorEntry"}>
          <span className={"plzSelect"}>{placeholder}</span>
          {/* <DownOutline fontSize={16} color="#101013" /> */}
        </div>
      ) : (
        <div className={"selectedItemWrapper"}>
          {(Array.isArray(checkedItems) ? checkedItems : [checkedItems])?.map(
            (item) => (
              <div key={item} className={'selectedItem'}>
                {selected?.find((i) => i.id === item)?.name || ''}
              </div>
            ),
          )}
        </div>
      )}

      {open && (
        <Popup
          visible={open}
          onMaskClick={() => setOpen(false)}
          style={{ height: "50%" }}
          destroyOnClose
        >
          <div className={"searchSelectorModal"} ref={modalConatinerRef}>
            <SearchBar
              placeholder="请输入内容"
              value={searchText}
              onChange={handleSearch}
              style={{
                height: "60px",
                fontSize: "16px",
                padding: "0 12px",
              }}
            />
            <div className={"listWrapper"}>
              <>
                {model === "multiple" ? (
                  <>
                    <Checkbox.Group
                      value={(Array.isArray(checkedItems)
                        ? checkedItems
                        : [checkedItems]
                      )?.map((item) => item)}
                    >
                      <List>
                        {allItems?.map((item) => (
                          <ListItem
                            key={Math.random().toString()}
                            item={item}
                            onClick={handleCheckboxChange}
                          />
                        ))}
                      </List>
                    </Checkbox.Group>
                    <InfiniteScroll
                      loadMore={() => {
                        console.log("loadMore");
                        return getAllItems(
                          {
                            searchTxt: searchText,
                          },
                          type,
                          false
                        );
                      }}
                      hasMore={hasMore}
                      threshold={50}
                    />
                  </>
                ) : (
                  <>
                    <Radio.Group
                      value={
                        Array.isArray(checkedItems)
                          ? checkedItems?.[0]
                          : checkedItems
                      }
                    >
                      <List>
                        {allItems?.map((item) => (
                          <ListItem
                            key={Math.random().toString()}
                            item={item}
                            onClick={handleRadioChange}
                          />
                        ))}
                      </List>
                    </Radio.Group>
                    <InfiniteScroll
                      loadMore={() => {
                        console.log("loadMore");
                        return getAllItems(
                          {
                            searchTxt: searchText,
                          },
                          type,
                          false
                        );
                      }}
                      hasMore={hasMore}
                      threshold={50}
                    />
                  </>
                )}
              </>
            </div>
            <Button
              color="primary"
              shape="rounded"
              style={{
                position: "fixed",
                bottom: 8,
                left: "50%",
                transform: "translateX(-50%)",
                width: "80%",
                height: "40px",
              }}
              onClick={handleConfirm}
            >
              确认
            </Button>
          </div>
        </Popup>
      )}
    </div>
  );
};

// 阅读态组件
const SelectReadPretty: React.FC<{ value: string }> = (props) => {
  return <div>{props.value}</div>;
};

export const SearchSelector = connect(
  SearchSelectorModel,
  mapProps((props) => {
    return {
      value: isValid(props.value) ? props.value : "",
    };
  }),
  mapReadPretty(SelectReadPretty)
);

export default SearchSelector;
